
import storage from '@/utils/storage'
import { defineComponent, onMounted, reactive } from 'vue'
import { useRouter } from 'vue2-helpers/vue-router'

type Path = {
	path: string
} | null

export default defineComponent({
	name: 'NotFound',

	setup() {
		// Router
		const router = useRouter()

		// Refs
		const state: { homePath: Path } = reactive({
			homePath: null
		})

		// Hooks
		onMounted(() => {
			const venueChain = storage.getStorage('lastVenueChainSubdomain')
			const venueId = storage.getStorage('lastVenueId')

			if (venueChain && venueId) {
				state.homePath = { path: `/${venueChain}/${venueId}` }
			}
		})

		// Methods
		const goHome = () => {
			if (state.homePath) router.push(state.homePath)
		}

		return { state, goHome }
	}
})
